import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UiMobileNavComponent } from './ui-mobile-nav/ui-mobile-nav.component';
import { TranslateModule } from '@ngx-translate/core';
import { PartnerWebUiMembershipButtonModule } from '@fitscovery/partner-web/ui/membership-button';

@NgModule({
  imports: [CommonModule, RouterModule, TranslateModule, PartnerWebUiMembershipButtonModule],
  declarations: [UiMobileNavComponent],
  exports: [UiMobileNavComponent],
})
export class SharedPartnerWebUiMobileNavModule {}
